module.exports = __webpack_public_path__ + "img/architectural-elements-0.8d662ddb.jpeg";